/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function MulticastGroupRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.applications.multicastGroups', {
            url: '/:applicationId/multicastGroups',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value,
            types.authority.SUB_CUSTOMER_ADMIN.value, types.authority.SUB_CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'multicast-group.multicast-groups'
            },
            ncyBreadcrumb: {
                label: '{"icon": "device_hub", "label": "multicast-group.multicast-groups"}'
            },
            params: {
                entityId: null,
            },
            resolve: {
                entityTableConfiguration:
                    /*@ngInject*/
                    function ($stateParams, multicastGroupTableConfig) {
                        return multicastGroupTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.subCustomers.applications.multicastGroups', {
            url: '/:applicationId/multicastGroups',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'multicast-group.multicast-groups'
            },
            ncyBreadcrumb: {
                label: '{"icon": "device_hub", "label": "multicast-group.multicast-groups"}'
            },
            resolve: {
                entityTableConfiguration:
                    /*@ngInject*/
                    function ($stateParams, multicastGroupTableConfig) {
                        return multicastGroupTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.multicastGroups', {
            url: '/multicastGroups',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value,
                   types.authority.SUB_CUSTOMER_ADMIN.value, types.authority.SUB_CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'multicast-group.multicast-groups'
            },
            ncyBreadcrumb: {
                label: '{"icon": "device_hub", "label": "multicast-group.multicast-groups"}'
            },
            params: {
                entityId: null,
            },
            resolve: {
                entityTableConfiguration:
                    /*@ngInject*/
                    function ($stateParams, multicastGroupTableConfig) {
                        return multicastGroupTableConfig.getConfig($stateParams);
                    }
            }
        })
}



// WEBPACK FOOTER //
// ./src/app/multicast-group/multicast-group.routes.js